import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Stream URL that goes through backend (for portfolio audio + auth-gated files)
export const fileUrl = (path) => `${API}/files/${path}`;
